import { render, staticRenderFns } from "./PaperManager.vue?vue&type=template&id=155fb006&scoped=true"
import script from "./PaperManager.vue?vue&type=script&lang=js"
export * from "./PaperManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155fb006",
  null
  
)

export default component.exports